import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollNav from "./ScrollNav";
import { Outlet } from "react-router-dom";

const Layout = ({ children }) => {
  return (
    <div className="bg-darkbg text-white min-h-screen">
      <Navbar />
      <ScrollNav color="text-navy" />

      {/* PAGE CONTENT */}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
